import { createRange, isRangeable, type SearchResult } from "@circleofa/acim-engine"

export function getSearchResultDisplayPath(result: Pick<SearchResult, "path" | "target">): string {
    if (isRangeable(result.target)) return createRange(result.target, result.target)
    return String(result.path)
}
